/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('RestoreNodeController', ['$scope', '$translate', '$modal', '$filter', 'SyncAndShareNode', 'operationComplete',
    function($scope, $translate, $modal, $filter, SyncAndShareNode, operationComplete) {
        var
            CONFLICT_ERROR_CODE = 409;

        $scope.restore = function() {
            var node = $scope.node;

            if(node.is_directory) {
                _restoreFolder();
            } else {
                _doRestore();
            }
        };

        function _restoreFolder() {
            var node = $scope.node;

            SyncAndShareNode.getContentsSize({ uuid: node.uuid }, function success(data) {
                if (data.files_count > 0) {
                    _showFolderRestoreModal(data, node);
                } else {
                    _doRestore();
                }
            }, function error(response) { _doRestore(); } );
        }

        function _showFolderRestoreModal(data) {
            var MODAL_TITLE = "Restore folder and contents",
                MODAL_TEXT = "Restoring the '%{node_name}' folder will restore the latest version of all files and subfolders inside it. This includes %{files_count} files (%{files_size}).",
                MODAL_BUTTON = "Restore",
                WAIT_TEXT = "This could take a few minutes.",
                node = $scope.node,
                fileSizeString = $filter('fileSize')(data.contents_size),
                modal_text = $translate.instant(MODAL_TEXT, { node_name: node.name, files_count: data.files_count, files_size: fileSizeString });

            if (data.files_count > 200) {
                modal_text += " " + $translate.instant(WAIT_TEXT);
            }

            $modal.open({
                domOptions: {
                    modalType: 'confirm',
                    modalAction: 'confirm',
                    modalTitle: $translate.instant(MODAL_TITLE),
                    modalBodyText: modal_text,
                    modalActionButton: $translate.instant(MODAL_BUTTON)
                },
                controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
                    $scope.modal = $modalInstance.options;

                    $scope.ok = function () {
                        $scope.modal.loading = true;
                        _doRestore($modalInstance);
                    };

                    $scope.cancel = function () {
                        $modalInstance.dismiss('cancel');
                    };

                    $scope.close = $scope.cancel;
                }],
                windowClass: 'confirmation-dialog',
                backdrop: 'static',
                keyboard: false
            });
        }

        function  _doRestore(modal) {
            var
                node = $scope.node;
            
            SyncAndShareNode.restore(node,
                function success() {
                    _hideModal(modal);
                    operationComplete(node.is_directory ? "Folder restored." : "File restored.");
                    _reloadNodes();
                },
                function error(response) {
                    _hideModal(modal);
                    if(response.status === CONFLICT_ERROR_CODE) {
                        // Name conflict can occur not for the node being restored itself
                        // but for the folder on top of the hierarchy of it's deleted parent nodes
                        var nodeWithNameConflict = response.data.error.context.conflict || node;
                        node.rename_to = nodeWithNameConflict.name;
                        node.rename_uuid = nodeWithNameConflict.uuid;

                        var modalInstance = $modal.open({
                            domOptions: {
                                modalTitle: $translate.instant(nodeWithNameConflict.is_directory ? 'Rename Folder for Restore' : 'Rename File for Restore'),
                                modalActionButton: $translate.instant('Retry restore'),
                                modalBodyTemplate: 'nodes/restore'
                            },
                            controller: 'RestoreRenameNodeController',
                            resolve: {
                                restoreNode: function () {
                                    return node;
                                },
                                conflictNode: function() {
                                    return nodeWithNameConflict;
                                }
                            }
                        });

                        modalInstance.result.then(function (response) {
                            switch (response) {
                                case 'reload_nodes':
                                    _reloadNodes();
                                    break;
                            }
                        }, function (response) {
                            switch (response) {
                                case 'reload_nodes':
                                    _reloadNodes();
                                    break;
                            }
                        });
                    } else {
                        _reloadNodes();
                    }
                });
        }

        function _reloadNodes() {
            $scope.$root.$broadcast('reload.dataTable');
            $scope.$root.$broadcast('reload.contentStats');
        }

        function _hideModal(modal) {
            if(modal) {
                modal.close('ok');
            }
        }
    }]);
